import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Box, CircularProgress, Typography } from '@mui/material'
import { APEX } from '../../../constants/businessTerritory'
import { NewLayout } from '../../../components/newLayout/NewLayout'
import { fetchRequest } from '../../../services/http.service'
import { OpsApiProvider } from '../api/context'
import { CurrentUserProvider } from '../auth'
import { OpsPage } from '../OpsPage'
import { opsApiHttp } from './OpsApiHttp'
import { toCurrentUser } from './currentUser'

interface FundConfig {
  enabled: boolean
}

/**
 * Vstupní bod modulu Apex Ops v portilio-fe. Zjistí per-tenant zapnutí přes
 * GET /api/funds/config (vypnuto = 404 → skryto), namapuje přihlášeného uživatele
 * z redux a poskytne OpsApi (HTTP) + CurrentUser modulu.
 */
export function OpsRoot() {
  const user = useSelector((s: any) => s.auth.user)
  const [state, setState] = useState<'loading' | 'enabled' | 'disabled'>('loading')

  useEffect(() => {
    let alive = true
    fetchRequest
      .get<FundConfig>('funds/config')
      .then((r) => {
        if (alive) setState(r.data && r.data.enabled ? 'enabled' : 'disabled')
      })
      .catch(() => {
        if (alive) setState('disabled')
      })
    return () => {
      alive = false
    }
  }, [])

  if (!user) {
    return null
  }

  // Modul se renderuje uvnitr NewLayout — stejna leva navigace jako zbytek aplikace.
  const pageName = user.businessTerritoryId === APEX ? 'Fond' : 'Generátor smluv'
  let content
  if (state === 'loading') {
    content = (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 6 }}>
        <CircularProgress />
      </Box>
    )
  } else if (state === 'disabled') {
    content = <Typography sx={{ p: 3 }}>Modul není pro tento účet dostupný.</Typography>
  } else {
    content = (
      <CurrentUserProvider value={toCurrentUser(user)}>
        <OpsApiProvider value={opsApiHttp}>
          <OpsPage />
        </OpsApiProvider>
      </CurrentUserProvider>
    )
  }

  return <NewLayout pageName={pageName}>{content}</NewLayout>
}
